
import { InputNumber as PrimereactInputNumber } from 'primereact/inputnumber';
import { ReactComponent as ValidationErrorIcon } from '../../assets/images/validation-error.svg';
import { ReactComponent as AddCircleIcon } from '../../assets/images/add-circle.svg';
import { ReactComponent as DelCircleIcon } from '../../assets/images/del-circle.svg';
import { classNames } from 'primereact/utils';

const InputNumber = ({ showLabel = true, label, validator, validations, ...rest }) => {
    const id = `number-${rest.id}`;
    const validationMessage = validator ? validator.message(id, label, rest.value, validations) : null;

    return (
        <div className="field">
            {showLabel && <label htmlFor={id}>{label}</label>}
            <PrimereactInputNumber {...rest} id={id} className={classNames('w-full', { 'p-invalid': validationMessage })} inputClassName='w-full' autoComplete='off'
                locale="pl-PL"
                incrementButtonIcon={<AddCircleIcon />}
                decrementButtonIcon={<DelCircleIcon />}
            />

            {validationMessage && <div className={"validation-error"}>
                <ValidationErrorIcon className='icon' />
                <div className="text">{validationMessage}</div>
            </div>}
        </div>
    )
}

export default InputNumber;